import { api } from '@lipaflow/shared'
import type { SchoolGrade, SchoolStream, SchoolDorm } from '@lipaflow/shared'

// --- Grades ---

export async function fetchGrades(): Promise<SchoolGrade[]> {
  const { data } = await api.get('/school-structure/grades')
  return data
}

export async function createGrade(payload: { code: string; display_name: string; sequence?: number }): Promise<SchoolGrade> {
  const { data } = await api.post('/school-structure/grades', payload)
  return data
}

export async function updateGrade(id: string, payload: Partial<{ display_name: string; sequence: number; is_active: boolean }>): Promise<SchoolGrade> {
  const { data } = await api.patch(`/school-structure/grades/${id}`, payload)
  return data
}

export async function deleteGrade(id: string): Promise<void> {
  await api.delete(`/school-structure/grades/${id}`)
}

// --- Streams ---

export async function fetchStreams(): Promise<SchoolStream[]> {
  const { data } = await api.get('/school-structure/streams')
  return data
}

export async function createStream(payload: { code: string; display_name: string }): Promise<SchoolStream> {
  const { data } = await api.post('/school-structure/streams', payload)
  return data
}

export async function updateStream(id: string, payload: Partial<{ display_name: string; is_active: boolean }>): Promise<SchoolStream> {
  const { data } = await api.patch(`/school-structure/streams/${id}`, payload)
  return data
}

export async function deleteStream(id: string): Promise<void> {
  await api.delete(`/school-structure/streams/${id}`)
}

// --- Dorms ---

export async function fetchDorms(): Promise<SchoolDorm[]> {
  const { data } = await api.get('/school-structure/dorms')
  return data
}

export async function createDorm(payload: { code: string; display_name: string; capacity?: number; gender?: string }): Promise<SchoolDorm> {
  const { data } = await api.post('/school-structure/dorms', payload)
  return data
}

export async function updateDorm(id: string, payload: Partial<{ display_name: string; capacity: number; gender: string; is_active: boolean }>): Promise<SchoolDorm> {
  const { data } = await api.patch(`/school-structure/dorms/${id}`, payload)
  return data
}

export async function deleteDorm(id: string): Promise<void> {
  await api.delete(`/school-structure/dorms/${id}`)
}
